module.exports = __webpack_public_path__ + "817035f39db126f66c810e179ee50676.fbx";